export function dispatchCartUpdated(cart: unknown) {
  document.dispatchEvent(
    new CustomEvent('cart:updated', {
      bubbles: true,
      detail: { cart },
    }),
  )
}
